import {Box, Button, Divider, Typography} from '@mui/material';
import {ChangeEvent, FC, FormEvent, useEffect, useState} from 'react';
import {FormattedMessage} from 'react-intl';
import {AMPInput} from 'src/components/common/AMPInput';
import {actionsWrapperSx, buttonSx, closeButtonSx, fieldsWrapperSx} from './ChangeStringValue.sx';
import {ChangeStringValueType} from './ChangeStringValue.types';

export const ChangeStringValue: FC<ChangeStringValueType> = ({name, handleClose, ...rest}) => {
    const [newValue, setNewValue] = useState<string>('');

    useEffect(() => {
        setNewValue(rest.value);
    }, []);

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        rest.onChange(newValue);
    };

    const handleChange = (e: ChangeEvent<any>) => {
        setNewValue(e.target.value);
    };

    return (
        <form
            onSubmit={handleSubmit}
            noValidate
        >
            <Box sx={fieldsWrapperSx}>
                <AMPInput
                    value={newValue}
                    type={'text'}
                    input={'value'}
                    onChange={handleChange}
                />
            </Box>
            <Divider/>
            <Box sx={actionsWrapperSx}>
                <Button
                    variant="outlined"
                    sx={closeButtonSx}
                    onClick={handleClose}
                >
                    <Typography
                        variant="button"
                        color="neutral.700"
                    >
                        <FormattedMessage id="cancel"/>
                    </Typography>
                </Button>
                <Button
                    type="submit"
                    variant="contained"
                    sx={buttonSx}
                >
                    <Typography variant="button">
                        <FormattedMessage id="save"/>
                    </Typography>
                </Button>
            </Box>
        </form>
    );
};
